import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid dashboard-3" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexEducation',
  setup(__props) {

const DesignView = defineAsyncComponent(() => import("@/components/theme/dashboards/education/DesignView.vue"))
const UpcomingClasses = defineAsyncComponent(() => import("@/components/common/UpcomingClasses.vue"))
const SchoolPerformance = defineAsyncComponent(() => import("@/components/theme/dashboards/education/SchoolPerformance.vue"))
const NoticeBoard = defineAsyncComponent(() => import("@/components/theme/dashboards/education/NoticeBoard.vue"))
const DetailsTable = defineAsyncComponent(() => import("@/components/theme/dashboards/education/DetailsTable.vue"))
const CourseTable = defineAsyncComponent(() => import("@/components/theme/dashboards/education/CourseTable.vue"))
const TimeSpent = defineAsyncComponent(() => import("@/components/theme/dashboards/education/TimeSpent.vue"))
const TodoList = defineAsyncComponent(() => import("@/components/theme/dashboards/education/TodoList.vue"))
const AssignmentsTable = defineAsyncComponent(() => import("@/components/theme/dashboards/education/AssignmentsTable.vue"))
const ScheduleView = defineAsyncComponent(() => import("@/components/common/ScheduleView.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Dashboard",
      educationdesc: "true",
      mains: "Education Dashboard",
      title: "Education"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(DesignView)),
        _createVNode(_unref(UpcomingClasses), {
          colClass: "col-xxl-3 col-xl-4 col-sm-6 order-sm-1 order-xl-0 box-col-5",
          cardClass: "card upcoming-card"
        }),
        _createVNode(_unref(SchoolPerformance)),
        _createVNode(_unref(NoticeBoard)),
        _createVNode(_unref(DetailsTable)),
        _createVNode(_unref(CourseTable)),
        _createVNode(_unref(TimeSpent)),
        _createVNode(_unref(TodoList)),
        _createVNode(_unref(AssignmentsTable)),
        _createVNode(_unref(ScheduleView), { colClass: "col-xxl-3 col-xl-5 col-sm-6 box-col-6" })
      ])
    ])
  ], 64))
}
}

})